import { useCallback, useState } from 'react';

/** Estado y validación de geolocalización para modales de entrega (LocationButton + dirección manual). */
export default function useDeliveryGeolocation() {
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [customLocation, setCustomLocation] = useState('');
  const [locationStatus, setLocationStatus] = useState('idle');
  const [attempts, setAttempts] = useState(0);
  const [errorMessage, setErrorMessage] = useState('');

  const validateLocation = useCallback(() => {
    if (locationStatus === 'success') {
      return !(location.latitude && location.longitude);
    }
    if (locationStatus === 'error') {
      return !customLocation.trim();
    }
    return true;
  }, [locationStatus, location, customLocation]);

  const resetGeolocation = useCallback(() => {
    setLocation({ latitude: null, longitude: null });
    setCustomLocation('');
    setLocationStatus('idle');
    setAttempts(0);
    setErrorMessage('');
  }, []);

  return {
    location,
    setLocation,
    customLocation,
    setCustomLocation,
    locationStatus,
    setLocationStatus,
    attempts,
    setAttempts,
    errorMessage,
    setErrorMessage,
    validateLocation,
    resetGeolocation,
  };
}
